import React from 'react'
import { Divider, Typography } from 'antd'
import DailyReport from '../../../../components/Kanban-Count-Accuracy/Report/DailyReport/DailyReport'

const DailyReportPage = ({ userData }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Daily Report
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <DailyReport />
        </>
    )
}

export default DailyReportPage